module.exports = __webpack_public_path__ + "img/home-logo-pi.49ff90a4.png";